import { Box, FormControlLabel, Switch, TextField } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { WebServiceLayerType } from "shared/common/stores/sidebarStore";

const ArcgisOptions = ({
  webServiceLayer,
  useOldConnection,
}: {
  webServiceLayer: WebServiceLayerType;
  useOldConnection: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 2,
        }}
      >
        <TextField
          label={t("add_layer.username")}
          variant="outlined"
          defaultValue={
            (useOldConnection &&
              webServiceLayer?.source_options?.generatetoken?.username) ||
            ""
          }
          size="small"
          sx={{ width: { xs: "calc(50% - 8px)", md: "calc(30% - 12px)" } }}
          onChange={(event) => {
            if (!webServiceLayer.source_options) {
              webServiceLayer.source_options = {};
            }
            if (!webServiceLayer.source_options.generatetoken) {
              webServiceLayer.source_options.generatetoken = {
                username: event.target.value,
                password: "",
              };
              return;
            }
            webServiceLayer.source_options.generatetoken.username =
              event.target.value;
          }}
        />
        <TextField
          label={t("add_layer.password")}
          variant="outlined"
          type="password"
          defaultValue={
            (useOldConnection &&
              webServiceLayer?.source_options?.generatetoken?.password) ||
            ""
          }
          size="small"
          sx={{ width: { xs: "calc(50% - 8px)", md: "calc(30% - 12px)" } }}
          onChange={(event) => {
            if (!webServiceLayer.source_options) {
              webServiceLayer.source_options = {};
            }
            if (!webServiceLayer.source_options.generatetoken) {
              webServiceLayer.source_options.generatetoken = {
                username: "",
                password: event.target.value,
              };
              return;
            }
            webServiceLayer.source_options.generatetoken.password =
              event.target.value;
          }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 2,
        }}
      >
        <TextField
          label={t("add_layer.token")}
          variant="outlined"
          defaultValue={
            (useOldConnection && webServiceLayer.source_options?.token) || ""
          }
          size="small"
          sx={{ width: { xs: "calc(50% - 8px)", md: "calc(30% - 12px)" } }}
          onChange={(event) => {
            if (webServiceLayer.source_options) {
              webServiceLayer.source_options.token = event.target.value;
            } else {
              webServiceLayer.source_options = {
                token: event.target.value,
              };
            }
          }}
        />
        <TextField
          label={t("add_layer.bearer_token")}
          variant="outlined"
          defaultValue={
            (useOldConnection &&
              webServiceLayer?.source_options?.bearertoken) ||
            ""
          }
          size="small"
          sx={{ width: { xs: "calc(50% - 8px)", md: "calc(30% - 12px)" } }}
          onChange={(event) => {
            if (webServiceLayer.source_options) {
              webServiceLayer.source_options.bearertoken = event.target.value;
            } else {
              webServiceLayer.source_options = {
                bearertoken: event.target.value,
              };
            }
          }}
        />
        {/* <TextField
            label={t("add_layer.server_type")}
            variant="outlined"
            size="small"
            defaultValue={
              useOldConnection && webServiceLayer?.source_options?.servertype
                ? webServiceLayer.source_options.servertype
                : useOldConnection
                ? ""
                : "FeatureServer"
            }
            sx={{ width: "calc(40% - 6px)" }}
            onChange={(event) =>
              (webServiceLayer.source_options.servertype = event.target.value)
            }
          /> */}
      </Box>
      <TextField
        label={t("add_layer.generate_token_url")}
        variant="outlined"
        defaultValue={
          (useOldConnection &&
            webServiceLayer?.source_options?.generatetokenurl) ||
          ""
        }
        size="small"
        sx={{ width: { xs: "100%", md: "calc(60% - 8px)" } }}
        onChange={(event) => {
          if (webServiceLayer.source_options) {
            webServiceLayer.source_options.generatetokenurl =
              event.target.value;
          } else {
            webServiceLayer.source_options = {
              generatetokenurl: event.target.value,
            };
          }
        }}
      />
      <FormControlLabel
        sx={{ width: "40%" }}
        control={
          <Switch
            defaultChecked={
              (useOldConnection &&
                webServiceLayer.source_options?.withCredentials) ||
              false
            }
          />
        }
        label={t("add_layer.switch_button_2")}
        onChange={(event, checked: boolean) => {
          if (webServiceLayer.source_options) {
            webServiceLayer.source_options.withCredentials = checked;
          } else {
            webServiceLayer.source_options = {
              withCredentials: checked,
            };
          }
        }}
      />
    </Box>
  );
};
export default ArcgisOptions;
